import 'jquery-ui/ui/widgets/tabs'
import 'select2'
import '../vendor/slick' // slick-carousel
import {
    loader
} from './loader'
import arrow from "../../images/arrow.svg";

export function remove_application() {
    $(document).on('click', '.btn-remove-app', function(e) {
        e.preventDefault();

        const modalWrapper = $(this).next('.remove-app-modal')
        modalWrapper.modal().on('show.bs.modal', function() {
            modalWrapper.find('.error').remove();
        });
    });

    $(document).on('click', '.remove-app', function(e) {
        e.preventDefault();

        const $this = $(this),
            modal = $this.closest('.remove-app-modal'),
            wrapper = $this.closest('.study-item');

        const data = {
            action: 'application_remove_app',
            application_id: $this.data('application-id'),
            student: $this.data('student'),
            _ajax_nonce: window.glob_obj.application_remove_app_nonce
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            beforeSend: function() {
                loader.show();
                modal.find('.error').remove();
            },
            success: function(response) {
                loader.hide();
                if (response.status === 'success') {
                    modal.modal('hide').on('hidden.bs.modal', function() {
                        wrapper.removeClass('status-0,status-1,status-2').addClass('status-3').prepend('<div class="study-item-row-archived"></div>');
                        wrapper.find('.btn-remove-app').hide();
                    });
                }
                if (response.status === 'error') {
                    $(`<p class="error text-danger">${response.message}</p>`).insertAfter(modal.find('.modal-body > p').eq(0));
                }
            },
            error: function(error) {
                loader.hide();
                console.log(error);
            }
        });
    });
}

export function restore_application() {
    $(document).on('click', '.restore-app', function(e) {
        e.preventDefault();

        const $this = $(this);
        const wrapper = $this.closest('.study-item');

        const data = {
            action: 'application_restore_app',
            application_id: $this.data('application-id'),
            _ajax_nonce: window.glob_obj.application_restore_app_nonce
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            beforeSend: function() {
                loader.show();
            },
            success: function(response) {
                loader.hide();
                if (response.status === 'success') {
                    wrapper.removeClass('status-3').addClass('status-0');
                    wrapper.find('.study-item-row-archived').remove();
                    wrapper.find('.btn-remove-app').show();
                }
            },
            error: function(error) {
                loader.hide();
                console.log(error);
            }
        });
    });
}

export function remove_document() {
    $(document).on('click', '.btn-remove-doc', function(e) {
        e.preventDefault();

        $(this).next('.remove-doc-modal').modal();
    });

    $(document).on('click', '.remove-doc', function(e) {
        e.preventDefault();

        const $this = $(this),
            file_id = $this.data('file-id'),
            modal = $this.closest('.remove-doc-modal'),
            file_wrapper = $this.closest('.file-row');

        const data = {
            action: 'application_remove_doc',
            file_id: file_id,
            application_id: $this.data('application-id'),
            type: $this.data('type'),
            student: $this.data('student'),
            _ajax_nonce: window.glob_obj.application_remove_doc_nonce
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            beforeSend: function() {
                loader.show()
            },
            success: function(response) {
                loader.hide();

                file_wrapper.find('.includes-files').remove();
                file_wrapper.find('.comment-col textarea').val('');
                file_wrapper.find('.change-status').removeClass('none approved declined');
                file_wrapper.find('.change-status[data-status=none]').addClass('none');
                file_wrapper.find('.status-group').attr('data-has-files', '0');
                file_wrapper.find('.upload-files').removeClass('disabled');

                modal.modal('hide');

                showTabsOnStateChange($this, response.stages);
                showTabsContentOnStateChange($this, response.content);
            },
            error: function(error) {
                loader.hide();
                console.log(error);
            }
        });
    });
}

export function submitStage() {
    $(document).on('click', '.submit-stage', function(e) {
        e.preventDefault();
        const $this = $(this);
        const application_id = $this.data('application-id');
        const stage = $this.data('stage');
        const student = $this.data('student');
        const submitted_status = $this.hasClass('submitted') ? 0 : 1;
        const data = {
            action: 'application_officially_submitted_status',
            application_id: application_id,
            stage: stage,
            student: student,
            submitted_status: submitted_status,
            _ajax_nonce: window.glob_obj.application_officially_submitted_status_nonce
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            beforeSend: function() {
                loader.show()
            },
            success: function(response) {
                loader.hide();
                if (response.status === 'success') {
                    if (parseInt(response.submitted_status)) {
                        $this.addClass('submitted').html('Officially submitted');
                    } else {
                        $this.removeClass('submitted').html('Officially submitted');
                    }
                }
            },
            error: function(error) {
                loader.hide();
                console.log(error);
            }
        });
    });
}

export function completeStage() {
    $(document).on('click', '.complete-stage', function(e) {
        e.preventDefault();

        const $this = $(this);
        const application_id = $this.data('application-id');
        const stage = $this.data('stage');
        const student = $this.data('student');

        const data = {
            action: 'application_complete_stage',
            application_id: application_id,
            stage: stage,
            student: student,
            _ajax_nonce: window.glob_obj.application_complete_stage_nonce
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            beforeSend: function() {
                loader.show()
            },
            success: function(response) {
                loader.hide();

                if (response.status === 'success') {
                    if (response.stage_status) {
                        $this.addClass('completed').html('Completed');
                    } else {
                        $this.removeClass('completed').html('Complete stage');
                    }
                    if (response.next_stage_html !== undefined && response.next_stage_num !== undefined) {
                        insertNextStageContent($this, response.next_stage_num, response.next_stage_html)
                    }
                    showTabsOnStateChange($this, response.stages);
                    showTabsContentOnStateChange($this, response.content);
                    checkAndActivateNextStage($this, response.stages);

                    if (response.evaluation_date) {
                        $this.closest('.stages-wrapper').find('.evaluation-date').html(response.evaluation_date)
                    }
                }
            },
            error: function(error) {
                loader.hide();
                console.log(error);
            }
        });
    });
}

export function enrolledStudent() {
    $(document).on('click', '.enrolled-student', function(e) {
        e.preventDefault();

        const $this = $(this);
        const application_id = $this.data('application-id');
        const student = $this.data('student');

        const data = {
            action: 'application_enrolled_student',
            application_id: application_id,
            student: student,
            _ajax_nonce: window.glob_obj.application_enrolled_student_nonce
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            beforeSend: function() {
                loader.show()
            },
            success: function(response) {
                loader.hide();

                if (response.status === 'success') {
                    if (response.enrolled_status) {
                        $this.addClass('completed');
                    } else {
                        $this.removeClass('completed');
                    }
                }
            },
            error: function(error) {
                loader.hide();
                console.log(error);
            }
        });
    });
}

export function acceptance_offer(element = null) {
    let selector = '.stages-wrapper .application-evaluation-button';
    if (element) {
        selector = element;
    }
    $(document).on('click', selector, function(e) {
        e.preventDefault();
        var $this = $(this),
            container = $this.closest('.application-evaluation'),
            type = $this.data('type'),
            app_id = $this.data('application-id'),
            student = $this.data('student');

        var data = {
            action: 'application_acceptance_offer',
            _ajax_nonce: window.glob_obj.application_acceptance_offer_nonce,
            type: type,
            application_id: app_id,
            student: student
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            beforeSend: function() {
                loader.show()
            },
            success: function(response) {
                loader.hide();
                showTabsOnStateChange($this, response.stages);
                showTabsContentOnStateChange($this, response.content);
                updateApplicationStatus($this, response.app_status);

                if (response.status === 'accepted' || response.status === 'decline') {
                    container.find('.application-evaluation-button-row').remove();
                    container.find('.application-evaluation-col__desc').remove();
                }
                if (response.status === 'accepted') {
                    checkAndActivateNextStage(container, response.stages);
                }
                if (response.status === 'grace') {
                    container.find('.application-evaluation-button__grace').closest('div').remove();
                    container.find('.application-evaluation-col__desc span').html(response.acc_date);
                }
                if (response.app_to_remove === true) {
                    $(document).find('.application-items .study-item').not(`[data-id*='${app_id}']`).each(function(ind, el) {
                        $(el).removeClass('status-*').addClass('status-3');
                        $(el).find('.btn-remove-app').remove();
                        if ($(el).find('.study-item-row-archived').length < 1) {
                            $(el).prepend('<div class="study-item-row-archived"></div>')
                        }
                    });
                }
            },
            error: function(error) {
                loader.hide()
                console.log(error);
            }
        });
    });
}

export function visa_status() {

    $(document).on('click', '.stages-wrapper .visa-status-button', function(e) {
        e.preventDefault();

        var $this = $(this),
            container = $this.closest('.visa-status'),
            type = $this.data('type'),
            app_id = $this.data('application-id'),
            student = $this.data('student');
        var data = {
            action: 'visa_status',
            _ajax_nonce: window.glob_obj.visa_status_nonce,
            type: type,
            application_id: app_id,
            student: student
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            beforeSend: function() {
                loader.show()
            },
            success: function(response) {
                loader.hide();
                showTabsOnStateChange($this, response.stages);
                showTabsContentOnStateChange($this, response.content);
                updateApplicationStatus($this, response.app_status);

                container.find('.visa_appointment_wrapper').remove();
                if (response.status === 'approved' || response.status === 'denied') {
                    container.find('.visa-status-button-row').remove();
                }
                if (response.status === 'approved') {
                    container.find('.visa-status-row__approved').css('display', 'flex');
                    if (response.app_date !== "") {
                        if (container.find('.visa_appointment_date_info').length === 0) {
                            container.find('.visa-status-row__heading').prepend(`
                            <p>My visa appointment date: <span style="font-weight: 600;" class="visa_appointment_date_info">${response.app_date}</span></p>
                        `);
                        } else {
                            container.find('.visa_appointment_date_info').text(response.app_date);
                        }
                    }

                }
                if (response.status === 'denied') {
                    container.find('.visa-status-row__denied').css('display', 'flex');
                }
            },
            error: function(error) {
                loader.hide()
                console.log(error);
            }
        });
    });
}

export function visa_upload() {
    $(document).on('click', '.upload-visa', function(e) {
        e.preventDefault();
        $(this).parent().find('input[type=file]').trigger('click');
    });
    $(document).on('change', '.visaUpload input[type=file]', function(e) {
        e.preventDefault();
        var i,
            file_input = $(this),
            file_row = file_input.closest('.file-row'),
            file_title = file_row.find('.docs-tooltip'),
            status_group = file_row.find('.status-group'),
            files_obj = file_input.prop('files'),
            error_class = 'file-upload-error',
            loading_class = 'file-upload-loading',
            form_data = new FormData();

        for (i = 0; i < files_obj.length; i++) {
            form_data.append('file[]', files_obj[i]);
        }
        form_data.append('action', 'visa_upload');
        form_data.append('application_id', file_input.data('application-id'));
        form_data.append('student', file_input.data('student'));

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            contentType: false,
            processData: false,
            data: form_data,
            beforeSend: function() {
                file_title.after('<div class="' + loading_class + '" style="margin-bottom: 20px;">Uploading...</div>');
                file_row.find('.' + error_class).remove();
            },
            success: function(response) {
                file_row.find('.' + loading_class).remove();

                file_input.val('');
                if (response.status === 'error') {
                    file_title.after('<div class="' + error_class + '">' + response.error_message + '</div>');
                }
                if (response.status === 'success') {
                    status_group.attr('data-has-files', '1');
                    file_row.find('.change-comment-row textarea').attr('readonly', false);

                    if (file_row.find('.includes-files').length) {
                        file_row.find('.includes-files').html(response.html);
                    } else {
                        file_title.after('<div class="includes-files" style="margin-bottom: 20px;">' + response.html + '</div>');
                    }

                    // activateStage(file_input);
                }
            },
            error: function(error) {
                file_row.find('.' + loading_class).remove();

                file_title.after('<div class="' + error_class + '">' + error.statusText + '</div>');
                file_input.val('');

                console.log(error);
            }
        });
    });
}

export function acceptance_upload() {
    $(document).on('click', '.upload-acceptance-confirmation', function(e) {
        e.preventDefault();
        $(this).parent().find('input[type="file"]').trigger('click');
    });
    $(document).on('change', '.acceptanceUpload input[type=file]', function(e) {
        e.preventDefault();
        var i,
            file_input = $(this),
            file_row = file_input.closest('.file-row'),
            file_title = file_row.find('.docs-tooltip'),
            status_group = file_row.find('.status-group'),
            files_obj = file_input.prop('files'),
            error_class = 'file-upload-error',
            loading_class = 'file-upload-loading',
            form_data = new FormData();

        for (i = 0; i < files_obj.length; i++) {
            form_data.append('file[]', files_obj[i]);
        }
        form_data.append('action', 'acceptance_upload');
        form_data.append('application_id', file_input.data('application-id'));
        form_data.append('student', file_input.data('student'));
        form_data.append('type', file_input.data('type'));

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            contentType: false,
            processData: false,
            data: form_data,
            beforeSend: function() {
                file_title.after('<div class="' + loading_class + '" style="margin-bottom: 20px;">Uploading...</div>');
                file_row.find('.' + error_class).remove();
            },
            success: function(response) {

                file_row.find('.' + loading_class).remove();

                file_input.val('');
                if (response.status === 'error') {
                    file_title.after('<div class="' + error_class + '">' + response.error_message + '</div>');
                }
                if (response.status === 'success') {
                    status_group.attr('data-has-files', '1');
                    file_row.find('.change-comment-row textarea').attr('readonly', false);

                    if (file_row.find('.includes-files').length) {
                        file_row.find('.includes-files').html(response.html);
                    } else {
                        file_title.after('<div class="includes-files" style="margin-bottom: 20px;">' + response.html + '</div>');
                    }
                }
            },
            error: function(error) {
                file_row.find('.' + loading_class).remove();

                file_title.after('<div class="' + error_class + '">' + error.statusText + '</div>');
                file_input.val('');

                console.log(error);
            }
        });
    });
    $(document).on('click', '.acceptance-status', function(e) {
        e.preventDefault();

        var $this = $(this),
            container = $this.closest('.btn-group'),
            type = container.data('type'),
            app_id = container.data('application-id'),
            student = container.data('student'),
            status = $this.data('status');

        if ($this.closest('.btn-group').attr('data-has-files') === '0') {
            return false;
        }

        var data = {
            action: 'acceptance_status',
            type: type,
            application_id: app_id,
            student: student,
            status: status
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            beforeSend: function() {
                loader.show()
            },
            success: function(response) {
                loader.hide()
                if (response.status === 'success') {
                    container.find('.acceptance-status').removeClass('none approved declined')
                    container.find('.acceptance-status[data-status=' + response.doc_status + ']').addClass(response.doc_status)

                    let upload_button = container.closest('.file-row').find('.upload-acceptance-confirmation')
                    upload_button.removeClass('disabled')
                    if (response.doc_status === 'approved') {
                        upload_button.addClass('disabled')
                    }

                    showTabsOnStateChange($this, response.stages);
                    showTabsContentOnStateChange($this, response.content);
                    checkAndActivateNextStage($this, response.stages);
                    updateApplicationStatus($this, response.app_status);
                }
            },
            error: function(error) {
                loader.hide()
                console.log(error);
            }
        });

    });
}

export function evaluation_upload() {
    $('.upload-evaluation').click(function(e) {
        e.preventDefault();
        $(this).siblings('input[type=file]').trigger('click');
    });
    $('.evaluationUpload input[type=file]').change(function(e) {
        e.preventDefault();
        var i,
            file_input = $(this),
            file_row = file_input.closest('.file-row'),
            file_title = file_row.find('.docs-tooltip'),
            status_group = file_row.find('.status-group'),
            files_obj = file_input.prop('files'),
            error_class = 'file-upload-error',
            loading_class = 'file-upload-loading',
            form_data = new FormData();

        for (i = 0; i < files_obj.length; i++) {
            form_data.append('file[]', files_obj[i]);
        }
        form_data.append('action', 'evaluation_upload');
        form_data.append('application_id', file_input.data('application-id'));
        form_data.append('student', file_input.data('student'));
        form_data.append('type', file_input.data('type'));

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            contentType: false,
            processData: false,
            data: form_data,
            beforeSend: function() {
                file_title.after('<div class="' + loading_class + '" style="margin-bottom: 20px;">Uploading...</div>');
                file_row.find('.' + error_class).remove();
            },
            success: function(response) {
                file_row.find('.' + loading_class).remove();

                file_input.val('');
                if (response.status === 'error') {
                    file_title.after('<div class="' + error_class + '">' + response.error_message + '</div>');
                }
                if (response.status === 'success') {
                    status_group.attr('data-has-files', '1');
                    file_row.find('.change-comment-row textarea').attr('readonly', false);

                    if (file_row.find('.includes-files').length) {
                        file_row.find('.includes-files').html(response.html);
                    } else {
                        file_title.after('<div class="includes-files" style="margin-bottom: 20px;">' + response.html + '</div>');
                    }
                }
            },
            error: function(error) {
                file_row.find('.' + loading_class).remove();

                file_title.after('<div class="' + error_class + '">' + error.statusText + '</div>');
                file_input.val('');

                console.log(error);
            }
        });
    });
}

export function evaluation_status() {
    $(document).on('click', '.stages-wrapper .evaluation-status', function(e) {
        e.preventDefault();
        var $this = $(this),
            container = $this.closest('.btn-group'),
            type = container.data('type'),
            app_id = container.data('application-id'),
            student = container.data('student'),
            status = $this.data('status');

        if ($this.closest('.btn-group').attr('data-has-files') === '0') {
            return false;
        }

        var data = {
            action: 'evaluation_status',
            type: type,
            application_id: app_id,
            student: student,
            status: status
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            beforeSend: function() {
                loader.show()
            },
            success: function(response) {
                loader.hide()
                if (response.status === 'success') {
                    container.find('.evaluation-status').removeClass('none approved declined')
                    container.find('.evaluation-status[data-status=' + response.doc_status + ']').addClass(response.doc_status)

                    let upload_button = container.closest('.file-row').find('.upload-evaluation')
                    upload_button.removeClass('disabled')
                    if (response.doc_status === 'approved') {
                        upload_button.addClass('disabled')
                    }

                    if (response.content[6] === 1) {
                        $(`#${response.stage_id}`).html(response.stage_html);

                        acceptance_offer()
                    }

                    showTabsOnStateChange($this, response.stages);
                    showTabsContentOnStateChange($this, response.content);
                    checkAndActivateNextStage($this, response.stages);
                    updateApplicationStatus($this, response.app_status);
                }
            },
            error: function(error) {
                loader.hide()
                console.log(error);
            }
        });

    });
}

export function submit_order_files() {
    $(document).on('click', '.upload-files', function(e) {
        e.preventDefault();
        $(this).parent().find('input[type=file]').trigger('click');

    });
    $(document).on('change', '.fileUpload input[type=file]', function(e) {
        e.preventDefault();

        var i,
            file_input = $(this),
            file_row = file_input.closest('.file-row'),
            file_title = file_row.find('.docs-tooltip'),
            status_group = file_row.find('.status-group'),
            files_obj = file_input.prop('files'),
            error_class = 'file-upload-error',
            loading_class = 'file-upload-loading',
            form_data = new FormData();

        for (i = 0; i < files_obj.length; i++) {
            form_data.append('file[]', files_obj[i]);
        }
        form_data.append('action', 'application_file_upload');
        form_data.append('type', file_input.data('type'));
        form_data.append('application_id', file_input.data('application-id'));
        form_data.append('file_id', file_input.data('file-id'));
        form_data.append('student', file_input.data('student'));

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            contentType: false,
            processData: false,
            data: form_data,
            beforeSend: function() {
                file_title.after('<div class="' + loading_class + '">Uploading...</div>');
                file_row.find('.' + error_class).remove();
            },
            success: function(response) {
                file_row.find('.' + loading_class).remove();

                file_input.val('');
                if (response.status === 'error') {
                    file_title.after('<div class="' + error_class + '">' + response.error_message + '</div>');
                }
                if (response.status === 'success') {
                    status_group.attr('data-has-files', '1');
                    file_row.find('.change-comment-row textarea').attr('readonly', false);

                    if (file_row.find('.includes-files').length) {
                        file_row.find('.includes-files').html(response.html);
                    } else {
                        file_title.after('<div class="includes-files">' + response.html + '</div>');
                    }
                }
            },
            error: function(error) {
                file_row.find('.' + loading_class).remove();

                file_title.after('<div class="' + error_class + '">' + error.statusText + '</div>');
                file_input.val('');

                console.log(error);
            }
        });
    });
}

export function submit_order_link() {
    $(document).on('click', '.add-link', function(e) {
        e.preventDefault();
        $(this).siblings('.add-link-form-wrapper').toggle();
    });
    $('.submit-link').click(function(e) {
        e.preventDefault();

        var file_input = $(this).siblings('input.link-input'),
            file_row = file_input.closest('.file-row'),
            file_title = file_row.find('.file-title'),
            status_group = file_row.find('.status-group'),
            loading_class = 'file-upload-loading',
            form_data = new FormData();

        form_data.append('action', 'application_link_upload');
        form_data.append('type', file_input.data('type'));
        form_data.append('application_id', file_input.data('application-id'));
        form_data.append('file_id', file_input.data('file-id'));
        form_data.append('student', file_input.data('student'));
        form_data.append('link', file_input.val());

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            contentType: false,
            processData: false,
            data: form_data,
            beforeSend: function() {
                file_title.after('<div class="' + loading_class + '">Uploading...</div>');
            },
            success: function(response) {
                file_row.find('.' + loading_class).remove();

                file_input.val('');
                if (response.status === 'success') {
                    status_group.attr('data-has-files', '1');
                    file_row.find('.change-comment-row textarea').attr('readonly', false);

                    if (file_row.find('.includes-files').length) {
                        file_row.find('.includes-files').html(response.html);
                    } else {
                        file_title.after('<div class="includes-files">' + response.html + '</div>');
                    }
                    file_row.find('.add-link-form-wrapper').toggle();
                }
            },
            error: function(error) {
                console.log(error);
            }
        });
    });
}

export function update_order_comment() {
    $(document).on('focusin', '.change-comment-row textarea', function(e) { // focusout
        if ($(this).attr('readonly') === undefined) {
            $(this).next().show();
        }
    });

    $(document).on('click', '.stages-wrapper .change-comment', function(e) {
        e.preventDefault();

        var $this = $(this),
            type = $this.data('type'),
            app_id = $this.data('application-id'),
            value = $this.prev('textarea').val(),
            file_id = $this.data('file-id'),
            student = $this.data('student');

        var data = {
            action: 'application_order_comment',
            type: type,
            application_id: app_id,
            file_id: file_id,
            student: student,
            value: value
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            beforeSend: function() {
                loader.show()
            },
            success: function(response) {
                loader.hide()
                $this.hide();
            },
            error: function(error) {
                loader.hide()
                console.log(error);
            }
        });
    });
}

export function update_order_status() {
    $(document).on('click', '.stages-wrapper .change-status', function(e) {
        e.preventDefault();
        var $this = $(this),
            container = $this.closest('.btn-group'),
            type = container.data('type'),
            app_id = container.data('application-id'),
            file_id = container.data('file-id'),
            student = container.data('student'),
            status = $this.data('status');

        if ($this.closest('.btn-group').attr('data-has-files') === '0') {
            return false;
        }

        var data = {
            action: 'application_order_status',
            type: type,
            application_id: app_id,
            file_id: file_id,
            student: student,
            status: status
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            beforeSend: function() {
                loader.show()
            },
            success: function(response) {
                loader.hide()
                if (response.status === 'success') {
                    container.find('.change-status').removeClass('none approved declined')
                    container.find('.change-status[data-status=' + response.doc_status + ']').addClass(response.doc_status)

                    let upload_button = container.closest('.file-row').find('.upload-files')
                    upload_button.removeClass('disabled')
                    if (response.doc_status === 'approved') {
                        upload_button.addClass('disabled')
                    }

                    showTabsOnStateChange($this, response.stages);
                    showTabsContentOnStateChange($this, response.content);
                    checkAndActivateNextStage($this, response.stages);

                    if (response.evaluation_date) {
                        container.closest('.stages-wrapper').find('.evaluation-date').html(response.evaluation_date)
                    }
                }
            },
            error: function(error) {
                loader.hide()
                console.log(error);
            }
        });

    });
}

export function update_order_data() {
    $(document).on('change', '.stages-wrapper input[type=radio], .stages-wrapper select.program-select', function(e) {
        let $this = $(this),
            type = $(this).data('type'),
            app_id = $(this).data('application-id'),
            student = $(this).data('student'),
            value = $(this).val();

        if (type === 'program') {
            value = [];
            $('select[data-application-id=' + app_id + ']').each(function() {
                value.push($(this).val())
            })
        }

        var data = {
            action: 'application_order_data',
            type: type,
            application_id: app_id,
            value: value,
            student: student
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            success: function(response) {
                showTabsOnStateChange($this, response.stages);
                showTabsContentOnStateChange($this, response.content);

                checkAndActivateNextStage($this, response.stages);

                // let st = $this.closest('.stages-wrapper');
                // if (response.stages[1] && !response.stages[2]) {
                //   st.tabs( "option", "active", 1 );
                // }
            }
        });
    });

    $(document).find('.program-select').select2().on('select2:select', function(e) {
        const val = e.params.data.element.value;
        $(e.target).val(val);
    });
}

export function update_order_data_agents() {
    $(document).on('change', '.stages-wrapper input[type=radio], .stages-wrapper select.program-select', function(e) {
        let $this = $(this),
            type = $(this).data('type'),
            app_id = $(this).data('application-id'),
            student = $(this).data('student'),
            value = $(this).val();

        if (type === 'program') {
            value = [];
            $('select[data-application-id=' + app_id + ']').each(function() {
                value.push($(this).val())
            })
        }

        var data = {
            action: 'application_order_data',
            type: type,
            application_id: app_id,
            value: value,
            student: student
        };

        $.ajax({
            url: window.glob_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: data,
            success: function(response) {}
        });
    });

    $(document).find('.program-select').select2().on('select2:select', function(e) {
        const val = e.params.data.element.value;
        $(e.target).val(val);
    });
}

export function initChecklistStagesAgents() {
    initTabs()
    $(document).find(".stages-wrapper .stages-header li").removeClass('completed').addClass('active')
}

export function initChecklistStages() {
    initTabs();
    $(document).find(".stages-wrapper").each(function() {
        let cont = $(this);
        cont.find('.stages-header > li').each(function(e) {
            if (!$(this).hasClass('completed') && !$(this).hasClass('active') && !$(this).hasClass('show')) {
                cont.tabs("disable", e);
            }
            // if ($(this).hasClass('active')) {
            //   cont.tabs( "option", "active", e );
            // }
        })
        cont.find('.completed:last-of-type').next()
    });
}

export function downloadStudentFiles() {
    $(document).on('click', '.files-download', function(e) {
        e.preventDefault();

        const $this = $(this),
            id = $this.data('order-id');

        $.ajax({
            url: window.sd_data.ajaxurl,
            method: 'POST',
            xhrFields: {
                responseType: 'blob'
            },
            data: {
                action: 'student_checklist_download',
                id: id,
                _ajax_nonce: window.sd_data.nonce_download
            },
            beforeSend: function() {
                loader.show()
            },
            success: function(response, textStatus, request) {
                loader.hide()

                var filename = request.getResponseHeader('Filename');
                var a = document.createElement('a');
                var url = window.URL.createObjectURL(response);
                a.href = url;
                a.download = filename;
                document.body.append(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            },
            error: function(error) {
                loader.hide()
                console.log(error);
            }
        });

    });
}

export function onSaveAccountForm() {
    fbq('track', 'CompleteRegistration');
}

function initTabs() {
    $(document).find('.stages-wrapper').tabs({
        create: function(event, ui) {
            var currentTab = $(this).tabs('option', 'active');
            if (currentTab === 0) {
                $(this).find('.prev').css('opacity', 0);
            }
        },
        activate: function(e, ui) {
            var currentTab = $(this).tabs('option', 'active');
            var totalTabs = $(this).find('ul.stages-header li').length;

            if (currentTab + 1 === totalTabs) {
                $(this).find('.next').css('opacity', 0);
            } else {
                $(this).find('.next').css('opacity', 1);
            }

            if (currentTab + 1 === 1) {
                $(this).find('.prev').css('opacity', 0);
            } else {
                $(this).find('.prev').css('opacity', 1);
            }

            $(this).find('.stages-switcher-wrapper').removeClass('stages-switcher-wrapper__hidden');
        }
    });
    $(document).find('.stages-header').slick({
        slidesToShow: 5,
        slidesToScroll: 3,
        infinite: false,
        dost: false,
        centerMode: true,
        centerPadding: '0',
        focusOnSelect: true,
        prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><img src="/wp-content/themes/buy2themeforest-child/dist/images/arrow-white.svg" /></button>`,
        nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button"><img src="/wp-content/themes/buy2themeforest-child/dist/images/arrow-white.svg" /></button>`,
    });
    $(document).on('click', '.slick-arrow', function(e) {
        if ($(this).hasClass('slick-prev')) {
            activateStage($(this), 'prev')
        }
        if ($(this).hasClass('slick-next')) {
            activateStage($(this))
        }
    });

    $(document).on('click', '.stages-switcher-wrapper button', function(e) {
        e.preventDefault();
        var cl = $(this).attr('class');
        var tabs = $(this).closest('.stages-wrapper');
        var stages = tabs.find('.stages-header');
        var currentTab = tabs.tabs('option', 'active');
        var totalTabs = tabs.find('ul.stages-header li').length;

        if (cl.includes('next') && (currentTab + 1) !== totalTabs) {
            stages.slick('slickNext');
            tabs.tabs('option', 'active', currentTab + 1);
        }
        if (cl.includes('prev') && currentTab !== 0) {
            stages.slick('slickPrev');
            tabs.tabs('option', 'active', currentTab - 1);
        }
    });


    $(document).on('click', '.stages-header li.active a, .stages-header li.completed a', function() {
        const cw = $(this).closest('.checklist-wrapper');
        cw.find($(this).attr('href')).show();
        cw.find('.stages-switcher-wrapper').removeClass('stages-switcher-wrapper__hidden');
    });
    $(document).on('click', '.toggle-checklist', function(e) {
        e.preventDefault();

        const cw = $(this).closest('.study-item').find('.checklist-wrapper');
        cw.find('.stages-tab-content').hide();
        cw.find('.stages-switcher-wrapper').addClass('stages-switcher-wrapper__hidden');
    });
}

function checkAndActivateNextStage(context, stages) {
    // const currentStage = context.closest('.stages-wrapper').find('.stages-header li.ui-state-active').data('stage');
    // if (stages[currentStage] === 1) {
    //   activateStage(context);
    // }
}

function activateStage(el, direction = 'next') {
    el.closest('.stages-wrapper').find(`.stages-switcher-wrapper button.${direction}`).trigger('click');

}

function showTabsOnStateChange(el, stages) {
    let st = el.closest('.stages-wrapper');

    for (let [key, value] of Object.entries(stages)) {
        if (value === 1) {
            st.find(`.stages-header li[data-stage="${key}"]`).addClass('completed');
            // st.find('.stages-header li').eq(key - 1).addClass('completed');
        } else {
            st.find(`.stages-header li[data-stage="${key}"]`).removeClass('completed');
            // st.find('.stages-header li').eq(key - 1).removeClass('completed');
        }
    }
}

function insertNextStageContent(el, stage_num, stage_content) {
    let st = el.closest('.stages-wrapper');
    st.find('.stages-tab-content').eq(stage_num - 1).html(stage_content);

    acceptance_offer('.stages-tab-content .application-evaluation-button');
}

function showTabsContentOnStateChange(el, content) {
    let st = el.closest('.stages-wrapper');

    for (let [key, value] of Object.entries(content)) {
        if (value === 1) {
            st.find('.stages-tab-content').eq(key - 1).find('.tab-content').addClass('show-content');
            st.find('.stages-tab-content').eq(key - 1).find('.no-content').addClass('hide-content');
        } else {
            st.find('.stages-tab-content').eq(key - 1).find('.tab-content').removeClass('show-content');
            st.find('.stages-tab-content').eq(key - 1).find('.no-content').removeClass('hide-content');
        }
    }
}

function updateApplicationStatus(el, statusObj) {
    const wrapper = el.closest('.study-item');
    const statusEl = wrapper.find('.application-status');

    statusEl.removeClass('status-0 status-1 status-2');
    statusEl.addClass(`status-${statusObj.id}`);
    statusEl.html(statusObj.title);

    wrapper.removeClass('status-0 status-1 status-2');
    wrapper.addClass(`status-${statusObj.id}`);
}

if (window.applications_page !== undefined) {
    $(document).on('click', '#application-fee-start', function(){
        $(this).hide();
        $(this).closest('.stages-tab-content').find('#stripe-form').show();

        const app_id = $(this).closest('.study-item-row').data('id');

        if ($('div.stripe-form[data-stripe-app_id="'+app_id+'"]').length === 0) {
            return;
        }

        let elements;
        try {
            const stripe = Stripe(window.glob_obj.stripe_public_key);
            $.ajax({
                url: window.glob_obj.ajaxurl,
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'stripe_create_payment',
                    app_id: app_id,
                },
                beforeSend: function() {
                    loader.show()
                },
                success: function(response) {
                    loader.hide();
                    const clientSecret = response.clientSecret;
                    elements = stripe.elements({ clientSecret });

                    const paymentElementOptions = {
                        layout: "tabs",
                    };

                    const paymentElement = elements.create("payment", paymentElementOptions);
                    paymentElement.mount('div.stripe-form[data-stripe-app_id="'+app_id+'"] .stripe_payment_element');
                },
                error: function(error) {
                    loader.hide();
                    console.log(error);
                }
            });

            $(document).on('click', '.form_pay_button', function (e){
                e.preventDefault();
                stripe_handle_submit(stripe, elements, app_id);
            });
        } catch( error ) {
            console.log( error );
            return;
        }
    })

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('appid') && urlParams.has('payment_intent') && urlParams.has('redirect_status')){
        const st = urlParams.get('redirect_status');
        if (st === 'succeeded'){
            const appid = urlParams.get('appid');
            const payment_intent = urlParams.get('payment_intent');
            loader.show();
            stripe_payment_success(appid, {'paymentIntent': payment_intent})
        }
    }
}


function stripe_payment_success(app_id, payment_data) {
    $.ajax({
        url: window.glob_obj.ajaxurl,
        method: 'POST',
        dataType: 'json',
        data: {
            action: 'application_fee_order_get',
            app_id: app_id,
            payment_data: payment_data,
        },
        success: function(response, textStatus, request) {
            const wrp = $('div.stripe-form[data-stripe-app_id="'+app_id+'"]').closest('.application-fee');
            wrp.html('<p>Application Fee is successfully paid.</p>');

            location.href = window.location.pathname;
        },
        error: function(error) {
            loader.hide();
            $(document).find('.application-fee').html('<p>Something gone wrong! Please try again later.</p>');
            console.log(error);
        }
    });

}

async function stripe_handle_submit(stripe, elements, app_id) {
    loader.show();

    $('div.stripe-form[data-stripe-app_id="'+app_id+'"] .errors').html('');

    stripe.confirmPayment({
        elements,
        confirmParams: {
            return_url: window.location.href + '?appid=' + app_id,
        },
        redirect: "if_required"
    }).then(function(result) {
        if (result.error) {
            loader.hide();
            console.log(result.error)
            $('div.stripe-form[data-stripe-app_id="'+app_id+'"] .errors').html(`<div>${result.error.message}</div>`);
        } else {
            stripe_payment_success(app_id,result);
        }
    });
}